// extracted by mini-css-extract-plugin
module.exports = {"searchResults":"searchResults-module--searchResults--1CCy7","header":"searchResults-module--header--BQhhO","searchList":"searchResults-module--searchList--2YVIX"};